import useAutoResizeToParent from './useAutoResizeToParent'
import ResellerEmbed from './ResellerEmbed'

/**
 * Auto-resizing per-grouping embed — the standard reseller embed.
 * Renders the widget unchanged and posts its height so the host iframe resizes
 * to fit. Safe for existing fixed-height embeds (they ignore the message).
 */
export default function AutoResizeEmbed() {
  useAutoResizeToParent()
  return <ResellerEmbed />
}
